import {BaseModel} from './base/base.model';
import {Deserializable} from './deserializable.model';

export class GeoDistrictModel extends BaseModel implements Deserializable {
    public code: string;
    public description: string;

    public constructor() {
        super();
    }

    public deserialize(input: any){
        Object.assign(this, input);
        return this;
    }
}
